<template>
	<div style="margin-top: -55px;" class="subsection-population">
		<div class="subsection-population-cont">
			<div class="sub-popu-title">
				<span>分段人数分布</span>
			</div>
			<div class="sub-popu-show">
				<div class="setting-class">
					<el-dialog title="选择班级" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
						<div class="class-title">
							<span>班级总数：{{ allSelectClassData.length }}</span>
							<span>已选中班级：{{ checkedclasses.length }}</span>
						</div>
						<p class="classTitle-p">提示： 为保证图表显示直观清晰，班级数量选择不能超过10个。</p>
						<div class="class-select">
							<div style="display: flex; flex-direction: column">
								<el-checkbox-group v-model="checkedclasses" @change="handleCheckedClassesChange">
									<el-checkbox v-for="(item, index) in allSelectClassData" :label="item.className" :key="index">
										{{ item.className }}
									</el-checkbox>
								</el-checkbox-group>
							</div>
						</div>
						<span slot="footer" class="dialog-footer">
							<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
							<el-button type="info" size="mini" @click="closeDialog">确 定</el-button>
						</span>
					</el-dialog>
				</div>
				<div class="charts-table" v-for="(item, index) in subjeckArr" :key="index">
					<render-sub-section-population
						:classData="item.newClassData"
						:classDataTitle="item.classDataTitle"
						:FractionX="item.FractionX"
						:max="item.max"
						:title="item.titleSub"
						:intervcal="item.intervcal"
						:className="subPopuCanvas + `${index + 1}`"
					/>
					<div class="subPopu-table-view">
						<div class="table-view-desc">
							<p>各分数段详细人数 - {{ item.subjeckName }}</p>
						</div>
						<div class="subPopu-table">
							<tables :tableOptions="item.subsectionData" v-if="tableState"></tables>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
		tables: () => import('hm-table'),
		renderSubSectionPopulation: () => import('./echarts/RenderSubSectionPopulation')
	},
	data() {
		return {
			subPopuCanvas: 'subPopuCanvas',
			dialogVisible: false,
			checked: true,
			className: '',
			titleSub: '',
			subjectTitle: '语文',
			allSelectClassData: [],
			selectClassData: [],
			checkedClassData: [],
			resultArr: [], //全部班级
			examSubjectData: [],
			subsectionData: [],
			classDataTitle: [],
			newClassData: [],
			FractionX: [],
			FractionNum: [],
			subjectGrade: '63',
			subject: '',
			newSubject: '',
			num: 1,
			newSubSection: [],
			checkedclasses: [],
			classesAll: [],
			max: 0,
			intervcal: 0,
			checkAllClass: false,
			indeterminate: false,
			tableState: true,
			newFlag: true,
			titleFlag: true,
			classIds: '',
			newClassIds: '',
			examSubjectScore: '',
			scoreSegment: '',
			newCheckedClasses: '',
			subjeckArr: [],
			query: this.$route.query
		}
	},
	// x`
	mounted() {
		// this.getClassData()
		this.getNewClassData()
	},
	methods: {
		getClassData(subjeckId, subjeckName) {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId,
				examSubjectId: subjeckId
				// classIds: newClassIds
			}
			this.$post( 'reportApi/partReportSchool', params).then(res => {
				// console.log(res)
				let subjectObj = {}
				this.subsectionData = []
				this.newClassData = []
				this.allSelectClassData = []
				this.examSubjectScore = res.data.examSubjectScore
				this.scoreSegment = res.data.scoreSegment
				this.subject = res.data.examSubjectId
				this.newCheckedClasses = res.data.classNames

				if (this.titleFlag) {
					this.titleSub = res.data.examSubjectName + '分数段详细人数'
					this.subjectTitle = res.data.examSubjectName
				}
				this.titleSub = subjeckName + '分数段详细人数'
				this.subjectTitle = subjeckName
				this.FractionX = []
				this.classesAll = res.data.classNameAll
				this.classDataTitle = res.data.classNames
				this.examSubjectData = res.data.examSubjectList
				if (res.code == '200') {
					this.subsectionData = res.data.table
					// console.log(this.subsectionData)
					if (this.newFlag) {
						let allData = []
						this.allSelectClassData = []
						res.data.classNameAll.forEach(item => {
							let classObj = {}
							classObj.className = item.className
							this.allSelectClassData.push(classObj)
						})
						// this.classDataTitle = this.allSelectClassData
						this.resultArr = []
						let resultArr1 = []
						res.data.classNumbers.split('|').forEach((item, index) => {
							allData.push(JSON.parse(item))
							let restluObj = {}
							restluObj.name = this.classDataTitle[index].className
							restluObj.data = JSON.parse(item)
							restluObj.type = 'bar'
							restluObj.barWidth = '10'
							restluObj.flag = true
							this.resultArr.push(restluObj)
						})
						res.data.classNumbers.split('|').forEach((item, index) => {
							allData.push(JSON.parse(item))
							resultArr1.push({
								name: this.classDataTitle[index].className,
								data: JSON.parse(item),
								type: 'bar',
								barWidth: '10',
								flag: true
							})
						})
						this.max = Math.max(...allData.flat(2))
						this.intervcal = Math.ceil(this.max / 10)
						this.newClassData = this.resultArr
						this.newClassDataFake = resultArr1
						if (this.resultArr.length > 10) {
							this.newClassData = this.resultArr.splice(0, 10)
						} else {
							this.newClassData = this.resultArr
						}
					} else {
						this.closeDialog()
					}
					this.subsectionData[0].forEach((item, index) => {
						if (index > 0) {
							this.FractionX.push(item)
						}
					})
					subjectObj.newClassData = this.newClassData
					subjectObj.FractionX = this.FractionX
					subjectObj.max = this.max
					subjectObj.subjeckName = subjeckName
					subjectObj.subsectionData = this.subsectionData
					subjectObj.classDataTitle = this.classDataTitle
					subjectObj.titleSub = this.titleSub
					subjectObj.intervcal = this.intervcal
					this.subjeckArr.push(subjectObj)
					// console.log(this.subjeckArr)
				}
			})
		},
		getNewClassData() {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId
				// examSubjectId: subjeckId,
				// classIds: newClassIds
			}
			this.$post( 'reportApi/partReportSchool', params).then(res => {
				res.data.examSubjectList.forEach(item => {
					// console.log(item)
					this.getClassData(item.pkId, item.subName)
				})
			})
		},
		openClassDialog() {
			this.checkedclasses = []
			this.dialogVisible = true
			this.newCheckedClasses.forEach(item => {
				this.checkedclasses.push(item.className)
			})
		},
		chageSelect(subjeckId) {
			this.titleFlag = false
			this.newSubjectId = subjeckId
			this.titleSub =
				this.examSubjectData.find(item => {
					return subjeckId === item.pkId
				}).subName + '分数段详细人数'
			this.subjectTitle = this.examSubjectData.find(item => {
				return subjeckId === item.pkId
			}).subName
			console.log(this.subjectTitle)
			this.getClassData(this.newSubjectId, this.newClassIds)
		},
		handleChange() {},
		handleClose(done) {
			done()
		},
		//全选
		choseAllClass() {
			this.indeterminate = false
			if (this.checkedclasses.length !== this.allSelectClassData.length) {
				this.checkedclasses = []
				this.allSelectClassData.forEach(res => {
					this.checkedclasses.push(res.className)
				})
			} else {
				this.checkedclasses = []
			}
		},
		//一个个选中班级
		handleCheckedClassesChange(val) {
			this.classIds = ''
			this.newClassIds = ''
			this.checkedclasses = val
			this.checkedclasses.forEach(newItem => {
				this.classesAll.forEach(item => {
					if (item.className == newItem) {
						this.classIds += item.classCode + ','
						this.newClassIds = this.classIds.slice(0, this.classIds.length - 1)
					}
				})
			})
			if (this.checkedclasses.length !== this.allSelectClassData.length && this.checkedclasses.length > 0) {
				this.indeterminate = true
				// console.log(val)
			}
			if (this.checkedclasses.length == 0) {
				this.newClassIds = '0'
			}
			console.log(this.newClassIds)
			console.log(this.checkedclasses)
		},
		closeDialog() {
			if (this.checkedclasses.length > 10) {
				this.$message('班级个数最多不能超过10个')
				this.dialogVisible - true
			} else {
				this.dialogVisible = false
			}
			// this.dialogVisible = false
			this.getClassData(this.newSubjectId, this.newClassIds) //newSubjectId
			// this.newFlag = false
			// let tempArr = []
			// let tempData = []
			// this.classDataTitle = []
			// console.log(this.newClassDataFake) //newClassDataFake数组包含的是全部班级
			// this.newClassDataFake.forEach(res => {
			// 	if (this.checkedclasses.includes(res.name)) {
			// 		tempArr.push(res)
			// 		tempData.push(res.data)
			// 		this.classDataTitle.push({ className: res.name })
			// 	}
			// })
			// if (tempArr.length > 10) {
			// 	this.newClassData = tempArr.splice(0, 10)
			// 	this.$message('为保证图表显示直观清晰，班级数量选择不能超过10个')
			// } else {
			// 	this.newClassData = tempArr
			// 	console.log(this.newClassData)
			// }
			// // this.newClassData = tempArr
			// this.max = Math.max(...tempData.flat(2))
			// this.interval = Math.ceil(this.max / 10)
		}
	}
}
</script>

<style lang="less" scoped>
.el-button--info {
	background-color: #009688;
	border-color: #009688;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #009688;
	border-color: #009688;
	color: #009688;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
	color: #009688;
}
/deep/.el-button:hover {
	background-color: #009688;
	border-color: #009688;
	color: white;
}
.subsection-population {
	height: auto;
	margin: 10px 0px;
	padding: 30px;
	border: 1px solid #ebeef5;
	background-color: #fff;
	color: #303133;
	-webkit-transition: 0.3s;
	transition: 0.3s;
	&:hover {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
	.subsection-population-cont {
		height: auto;
		.sub-popu-title {
			margin-bottom: 10px;
			> span {
				font-weight: bold;
				font-size: 18px;
				color: #333;
				margin-right: 20px;
			}
		}
		.sub-popu-show {
			height: auto;
			.sub-popu-title {
				background-color: #fafafa;
				padding: 10px 20px;
				border-radius: 5px;
				display: flex;
				> div {
					display: flex;
					align-items: center;
					flex-grow: 1;
					> p {
						font-size: 14px;
					}
					// > p:nth-child(2) {
					// 	margin-left: 5px;
					// }
					/deep/.el-select,
					.el-input-number {
						width: 100.36px;
						margin: 0 5px;
					}
				}
				.select-class {
					display: flex;
					justify-content: flex-end;
				}
			}
			.setting-class {
				.class-title {
					display: flex;
					align-items: center;
					margin-bottom: 10px;
					> span {
						flex-grow: 1;
					}
				}
				.classTitle-p {
					font-size: 12px;
					color: #f56c6c;
				}
				.class-select {
					display: flex;
					flex-direction: column;
					height: 300px;
					// background-color: antiquewhite;
					margin-top: 10px;
					margin-left: 30px;
				}
				/deep/.el-dialog {
					width: 50% !important;
				}
				/deep/.el-dialog__body {
					padding: 14px 20px;
				}
				/deep/.el-input {
					width: 20%;
				}
				/deep/.el-checkbox {
					margin-bottom: 5px;
				}
				/deep/.el-checkbox-group {
					display: flex;
					flex-direction: column;
				}
				/deep/.el-checkbox-group {
					height: 320px;
					overflow-y: scroll;
				}
			}
			.subPopuCanvas {
				height: 360px;
				margin: 10px 0;
				background-color: #fff;
			}
			.subPopu-table-view {
				height: auto;
				margin-top: 40px;
				// background-color: violet;
			}
			.table-view-desc {
				height: auto;
				display: flex;
				align-items: center;
				box-sizing: border-box;
				margin-bottom: 5px;
				> p {
					text-align: left;
					-webkit-box-flex: 1;
					-ms-flex: 1;
					flex: 1;
					font-size: 14px;
					line-height: 40px;
				}
			}
			.subPopu-table {
				height: auto;
			}
		}
	}
}
</style>
